import { Footer, ModalContainer } from "../export/ModalContainer";
import { closeModal, lockModal, ModalEnum, unlockModal } from "../model/modals";
import { Secondary } from "../share/Secondary";
import { Spinner } from "../utils/Spinner";
import { appNoteStore } from "../model/services";
import { exportNotes, ExportType } from "../export/ExportModalContent";
import { useLogoutAllTabs } from "./Logout";
import { useAuth } from "./useAuth";

export default function UnsyncedLogoutModalContent() {
  const { logoutAllTabs, isLoggingOut } = useLogoutAllTabs();
  const { user } = useAuth();

  const numberOfUnsyncedNotes = appNoteStore.getDirtyNodeIds().length;

  const handleConfirm = async () => {
    lockModal(ModalEnum.UNSYNCED_LOGOUT);
    await logoutAllTabs(true);
    unlockModal(ModalEnum.UNSYNCED_LOGOUT);
  };

  const exportUnsyncedNotes = () => {
    if (!user) return;
    const dirtyNoteIds = appNoteStore.getDirtyNodeIds();
    const notes = appNoteStore.settle(dirtyNoteIds);
    exportNotes(notes, user.id, ExportType.JSON);
  };

  return (
    <ModalContainer type={ModalEnum.UNSYNCED_LOGOUT}>
      <div>
        <h1>Logout with unsynced data?</h1>
        <p>
          You have made changes to {numberOfUnsyncedNotes || "your"} notes that have not been synced. Logging out now
          will lose these changes. Are you sure you want to log out?{" "}
        </p>
        <Footer>
          {isLoggingOut ? (
            <div style={{ display: "flex", justifyContent: "center", width: 100 }}>
              <Spinner style={{ width: 30, height: 30 }} />
            </div>
          ) : (
            <Secondary onClick={handleConfirm}>Confirm</Secondary>
          )}
          <Secondary onClick={() => closeModal(ModalEnum.UNSYNCED_LOGOUT)} disabled={isLoggingOut}>
            Cancel
          </Secondary>
          <Secondary onClick={exportUnsyncedNotes} disabled={isLoggingOut}>
            Export Unsynced Notes
          </Secondary>
        </Footer>
      </div>
    </ModalContainer>
  );
}
